import React from "react";
import './resultComponent.css'
import {ScenarioComponent} from "./scenarioComponent";
import {BingoRenoAdvise} from "../domain/bingoRenoAdvise";
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import {Links} from "../domain/Links";


export function ResultComponent() {

    const navigate = useNavigate()

    const location = useLocation()
    if (!location.state) {
        return <Navigate to='/'></Navigate>
    }
    const advise = JSON.parse(location.state) as BingoRenoAdvise


    return (
        <div className='Result'>
            <h1>Nos recommandations de travaux dans votre maison&nbsp;:</h1>
            <div className='Result-content'>
                <div className='Result-list'>
                    {buildScenario(advise)}
                </div>

                <div className='Result-Asterix'>
                    <p>* Coût estimé pour une maison de 130m² à 2 niveaux, sur la base des prix moyens de travaux
                        constatés début 2024.</p>
                </div>
                <div className='Result-comment'>
                    <p>Ces scénarios sont donnés à titre indicatif à partir de premières informations sur votre
                        logement.</p>
                    <p><b>Si vous avez envie de rénover votre maison, sachez qu'il existe des aides financières, parfois
                        très importantes.</b><br></br>
                        Des conseillers énergie sont à votre service pour vous aider à définir
                        vos travaux et vous accompagner tout au long de la rénovation.
                    </p>
                </div>
            </div>
            <h3>Pour aller plus loin :</h3>
            <div className='commands'>
                <a target='_blank' rel='noreferrer'
                   href={Links.HelpSimulator}>
                    <span>Simuler mes aides</span></a>
                <a target='_blank' href={Links.ContactAdviser}>
                    <span>Contacter un conseiller</span></a>
                <a target='_blank' rel='noreferrer'
                   href='https://www.grenoblealpesmetropole.fr/780-foire-aux-questions-sur-la-renovation-energetique.htm'>
                    <span>Foire aux questions</span></a>
            </div>
            <div className='commands'>
                <button onClick={printSimulation()}>Imprimer ma simulation</button>
                <button onClick={restartSimulation()}>Faire une nouvelle simulation</button>
            </div>
        </div>);

    function buildScenario(advise: BingoRenoAdvise) {
        return (
            <>
                {advise.scenario
                    .map((s: any, index: number) => {
                        return <ScenarioComponent key={index} index={index + 1} scenario={s}/>;
                    })}
            </>
        );
    }

    function restartSimulation() {
        return () => {
            navigate(-1)
        }
    }

    function printSimulation() {
        return () => {
            window.print()
        }
    }
}

